<template lang="pug">
RollInfoPanel
  .product-select
    .row
      .col-sm-12
        .form-group
          label Product
          .input
            ProductSelect(v-model="productId")
    .row
      .col-xs-12.text-right
        button.btn.btn-primary(@click="next()" :disabled="!productId") Continue
</template>
<script>
import ProductSelect from '@/components/ssp/ProductSelect'
import RollInfoPanel from '../components/RollInfoPanel'
import activationSession from '../service/ActivationSession'

export default {
  data: () => ({
    productId: activationSession.getProduct() || null
  }),
  methods: {
    next() {
      activationSession.setProduct(this.productId)
      this.$emit('next')
    }
  },
  components: {
    ProductSelect,
    RollInfoPanel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/activator/wiz/AssignProduct.vue